import React, { memo } from "react";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { LoaderContainer } from "components";

interface LoaderProps {
    title?: string;
}

const Loader = ({ title }: LoaderProps) => {
    return (
        <LoaderContainer>
            <CircularProgress />
            {title && (
                <Typography component="div" variant="subtitle2">
                    <Box p={1} textAlign="center" width="100%">
                        {title}
                    </Box>
                </Typography>
            )}
        </LoaderContainer>
    );
};

export default memo(Loader);
